const FLAG_MAINTENANCE_MODAL = 'maintenance-modal';

export { FLAG_MAINTENANCE_MODAL };
